import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LanguageLocaleService } from './services/language-locale.service';
import { LanguageService } from './services/language.service';
import { UserLanguageService } from './services/user-language.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    LanguageService,
    UserLanguageService,
    LanguageLocaleService
  ]
})
export class LanguageModule {}
